import React from "react";
import { Container, Grid, Box, Button } from "@mui/material";
import "../styles/Section1.css";
import tele2 from "../assets/Images/tele2.png";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import CurrencyExchangeRoundedIcon from "@mui/icons-material/CurrencyExchangeRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";

const WalletSection = () => {
  return (
    <Box className="wallet-section-wrap" id="wallet">
      <Container maxWidth="xl">
        <Grid container spacing={6} alignItems="center">
          {/* Left: Interactive Phone Mockup with tele2.png */}
          <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                position: "relative",
                maxWidth: "340px",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  background: "radial-gradient(circle, rgba(19, 91, 236, 0.18) 0%, rgba(19, 91, 236, 0) 70%)",
                  filter: "blur(30px)",
                  zIndex: 0,
                }}
              />
              <img
                src={tele2}
                alt="Telemedicine My Wallet Mockup"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  position: "relative",
                  zIndex: 1,
                  filter: "drop-shadow(0 20px 40px rgba(19, 91, 236, 0.2))",
                  borderRadius: "32px",
                }}
              />
            </Box>
          </Grid>

          {/* Right: Feature Description */}
          <Grid item xs={12} md={6}>
            <Box sx={{ maxWidth: "560px" }}>
              <div className="wallet-badge">
                <AccountBalanceWalletRoundedIcon sx={{ fontSize: 16 }} />
                <span>Smart Medical Wallet</span>
              </div>

              <h2 className="wallet-heading">
                Transparent Health Payments. Zero Surprises. Instant Refunds.
              </h2>

              <p className="wallet-subtext">
                Fund your in-app wallet in Naira (₦) with instant debit cards or bank transfers.
                Track every medical appointment, manage consultations, and receive automated
                instant refunds straight into your balance.
              </p>

              <div className="wallet-feature-item">
                <div className="wallet-feature-icon">
                  <AddCircleOutlineRoundedIcon sx={{ fontSize: 20 }} />
                </div>
                <div>
                  <div className="wallet-feature-title">Instant Wallet Top-Up</div>
                  <div className="wallet-feature-desc">
                    Add funds seamlessly (e.g. + NGN 100,000) so your family is always covered for emergency or routine consultations.
                  </div>
                </div>
              </div>

              <div className="wallet-feature-item">
                <div className="wallet-feature-icon">
                  <CurrencyExchangeRoundedIcon sx={{ fontSize: 20 }} />
                </div>
                <div>
                  <div className="wallet-feature-title">Flat Transparent Consultation Fees</div>
                  <div className="wallet-feature-desc">
                    Know exactly what you pay ahead of time: routine checkups and specialist sessions starting from ₦15,000 to ₦20,000.
                  </div>
                </div>
              </div>

              <div className="wallet-feature-item">
                <div className="wallet-feature-icon">
                  <CheckCircleRoundedIcon sx={{ fontSize: 20 }} />
                </div>
                <div>
                  <div className="wallet-feature-title">Guaranteed Instant Refunds</div>
                  <div className="wallet-feature-desc">
                    If an appointment is cancelled or your specialist is unavailable, get your full consultation fee (+ NGN 20,000) credited back immediately.
                  </div>
                </div>
              </div>

              <div className="wallet-feature-item">
                <div className="wallet-feature-icon">
                  <HistoryRoundedIcon sx={{ fontSize: 20 }} />
                </div>
                <div>
                  <div className="wallet-feature-title">Real-time Transaction History</div>
                  <div className="wallet-feature-desc">
                    Download receipts for insurance claims or personal bookkeeping directly from your mobile transactions ledger.
                  </div>
                </div>
              </div>

              <Box sx={{ mt: 4 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#135BEC",
                    color: "#FFFFFF",
                    fontWeight: 700,
                    fontSize: "15px",
                    px: 3.5,
                    py: 1.4,
                    borderRadius: "12px",
                    textTransform: "none",
                    boxShadow: "0 6px 20px rgba(19, 91, 236, 0.3)",
                    "&:hover": {
                      bgcolor: "#0D4BCA",
                    },
                  }}
                >
                  Create Patient Wallet
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default WalletSection;
